<template>
    <div>
        <v-toolbar class="text-md-center text-sm-center"
          :clipped-left="$vuetify.breakpoint.lgAndUp"
          color="primary"
          dark
          app
          fixed 
        >
          
          <v-toolbar-side-icon class="mr-3"  style="margin-left: -13px;" large @click.stop="drawer = !drawer"></v-toolbar-side-icon>
          
          <div class="mb-3 pt-4"><img style="height:24px;" src="/images/logo-inverse.png" @click="moveToDashboard"></div>
          <v-spacer></v-spacer>

          <div class="text-xs-center">
          
          <v-menu  offset-y v-for="item in users" style="margin-right:-43px;">
                <v-btn color="white" large style=" height: 60px;" flat class="white--text" slot="activator" >
                        <v-avatar color="white" size="35" class="mr-3">
                                <span class="primary--text headline " v-if="user_name">{{user_name[0]}}</span>
                        </v-avatar>
                        <span class="hidden-sm-and-down"  color="white">{{user_name}}</span>
                </v-btn>
                <v-list class="mt-3">
              <v-list-tile
                v-for="(item, index) in items_small"
                :key="index"
                @click=""
              >
                <router-link tag="li" :to="item.link">
                  <v-list-tile-title>
                    <v-icon class="mr-2">{{ item.icon }}</v-icon>{{ item.title }}
                  </v-list-tile-title>
                </router-link>
              </v-list-tile>
            </v-list>
        </v-menu>
          
          
        </div>
          
          
        </v-toolbar>
       
        <v-navigation-drawer v-model="drawer" :clipped="$vuetify.breakpoint.lgAndUp" fixed app v-bind:width="250" >
          <v-list>
        <v-list-tile
          v-for="(item, index) in links"
          :key="index"
          :to="item.plink"
        >
          <v-list-tile-action>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title><span style="font-size:13px;">{{ item.name }}</span></v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
      
        </v-navigation-drawer>

    </div>
</template>

<script>

    import global from '@/components/rbconstants';

    export default {
    data: () => ({
        app_name : global.app_name,
        drawer: null,
        links: [],
                
                users: [],
          items: [
            { icon: 'contacts', text: 'Contacts', link : 'dashboard' },
            { icon: 'history', text: 'Frequently contacted', link : 'dashboard-test' },
            { icon: 'content_copy', text: 'Duplicates', link : 'dashboard-test' },
            {
              icon: 'keyboard_arrow_up',
              'icon-alt': 'keyboard_arrow_down',
              text: 'Labels',
              model: true,
              link : 'dashboard-test',
              children: [
                { icon: 'add', text: 'Create label' }
              ]
            },
            {
              icon: 'keyboard_arrow_up',
              'icon-alt': 'keyboard_arrow_down',
              text: 'More',
              model: false,
              link : 'dashboard-test',
              children: [
                { text: 'Import' },
                { text: 'Export' },
                { text: 'Print' },
                { text: 'Undo changes' },
                { text: 'Other contacts' }
              ]
            },
            { icon: 'settings', text: 'Settings', link : 'dashboard-test' },
            { icon: 'chat_bubble', text: 'Send feedback', link : 'dashboard-test' },
            { icon: 'help', text: 'Help', link : 'dashboard-test' },
            { icon: 'phonelink', text: 'App downloads', link : 'dashboard-test' },
            { icon: 'keyboard', text: 'Go to the old version', link : 'dashboard-test' }
          ],
          
          items_small: [
            { title: 'My Profile', icon : 'person', link : '/profile' },
            { title: 'Logout', icon : 'logout', link : '/logout' },
          ],
          
          
          user_name : '',
    }),
    mounted: function () {
        
        this.check_already_login()
        
        this.getMenuList()
        
        this.url_menu()
        
        var user_details = localStorage.getItem('user');
        
        if(user_details) {

          user_details = JSON.parse(user_details);
          user_details = user_details[0];
          this.user_name = user_details.firstname;
          
        }
    },
    
    methods : {
      
      check_already_login: function() {
            
          var app = this
          
          if(localStorage.getItem('token')) {
          
              if(localStorage.getItem('token') != "undefined" || localStorage.getItem('token')  != '') {
              
                  // app.$router.push('/dashboard')
              
              }
          
          } else {
          
              app.$router.push('/')
          
          }
      
      },
      
      redirectTo (link) {
  
                this.$router.push(link)
  
            },
            
      moveToDashboard : function () {
        
        var app = this
        
        app.$router.push({ name: 'DashBoard'})
        
      },
      
      getMenuList: function () {
            
                if(localStorage.getItem('route_list')) {
                
                    this.links = JSON.parse(localStorage.getItem('route_list'));
                    
                }
                
                if(localStorage.getItem('user')) {
                
                    this.users = JSON.parse(localStorage.getItem('user'));
                    
                 
                
                }
            
            },
            
          url_menu : function() {
                
                /*this.links = JSON.parse(localStorage.getItem('route_list'));
            
                var array_length = this.links.length
                
                var i = 0
                
                for (i = 0; i < array_length; i++) { 
                  
                    var permission_count = this.links[i]['permissions'].length
                        
                    var j = 0
                
                    for (j = 0; j < permission_count; j++) { 
                 
                        if(this.links[i]['permissions'][j]['pslug'] == this.$route.path) {
                           
                            this.links[i]['active'] = true
            
                        }
                    }
       
                }  */              

            },
            
      
    }
  };
</script>
